import { getAnalyticsActor, posthog } from './posthog'

export type OrderListSurface = 'table' | 'cards'
export type OrderSearchMatchKind = 'exact_code' | 'partial' | 'none'

interface OpenedOrder {
    order_code: string
    internal_order_code?: string | null
}

/**
 * How the opened row matched the search box, derived locally so the query
 * text itself (slip codes, names, phone numbers) never leaves the browser.
 */
export function classifyOrderSearchMatch(
    query: string | undefined,
    order: OpenedOrder,
): OrderSearchMatchKind {
    const q = query?.trim().toLowerCase()
    if (!q) return 'none'
    const codes = [order.internal_order_code, order.order_code].map((code) =>
        code?.trim().toLowerCase(),
    )
    return codes.includes(q) ? 'exact_code' : 'partial'
}

/**
 * Staff open an order from `/orders` after searching its slip code; the
 * absolute position of the opened row tells whether the wanted order is
 * already on top or has to be hunted for.
 */
export function captureOrderListResultOpened(input: {
    query: string | undefined
    order: OpenedOrder
    index: number
    page: number
    perPage: number
    surface: OrderListSurface
}) {
    try {
        const actor = getAnalyticsActor()
        if (!actor) return
        const matchKind = classifyOrderSearchMatch(input.query, input.order)
        posthog.capture('order_list_result_opened', {
            schema_version: 1,
            event_id: crypto.randomUUID(),
            ...actor,
            route_template: '/orders',
            surface: input.surface,
            search_active: matchKind !== 'none',
            match_kind: matchKind,
            result_position: (input.page - 1) * input.perPage + input.index + 1,
            page: input.page,
        })
    } catch {
        // Analytics must never block opening an order.
    }
}
